import React, { useState } from 'react'
import axios from 'axios'
import { Typography, Button } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import DefaultDialog from '../../common/DefaultDialog'

const endpointsAccess: any = []

const useStyles = makeStyles(() => ({
    NoEndpointsText: {
        paddingBottom: '1rem',
    },
    NoEndpointsButtonContainer: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
    },
}))

/**
 * @description component to display noendpointsalert
 */
const NoEndpointsAlert = () => {
    const [endpoints, setEndpoints] = useState<any[]>([])
    const [displayAlert, setDisplayAlert] = useState(false)

    const classes = useStyles()

    /**
     * @description run http get requests on mandatory endpoints
     * will display endpoints in error
     */
    const runAccessCheck = async () => {
        const endpointErrors: any[] = []
        for (const endpoint of endpointsAccess) {
            try {
                await axios.get(endpoint)
            } catch (error) {
                endpointErrors.push(endpoint)
            }
        }
        setEndpoints(endpointErrors)
        if (endpointErrors.length > 0) setDisplayAlert(true)
    }

    React.useEffect(() => {
        runAccessCheck()
    }, [])

    return (
        <DefaultDialog
            isTiny
            largePadding
            title="Avertissement"
            open={displayAlert}
            withQuitButton={false}
            disableBackdropClick
            isFixedButtons
            buttons={
                <div className={classes.NoEndpointsButtonContainer}>
                    <Button
                        disableElevation
                        variant="contained"
                        color="secondary"
                        onClick={() => {
                            setDisplayAlert(false)
                        }}
                    >
                        Poursuivre quand même
                    </Button>
                </div>
            }
        >
            <Typography>
                Votre configuration réseau semble ne pas autoriser l'utilisation des noms de domaine suivants :{' '}
            </Typography>
            <ul>
                {endpoints &&
                    endpoints.length > 0 &&
                    endpoints.map((endpoint, index) => (
                        // eslint-disable-next-line react/no-array-index-key
                        <li key={index}>
                            <Typography>{endpoint}</Typography>
                        </li>
                    ))}
            </ul>
            <Typography>
                Veuillez vous rapprocher de votre support réseau afin d'en autoriser l'accès pour profiter de toutes les
                fonctionnalités de TokTokDoc.
            </Typography>
            <Typography className={classes.NoEndpointsText}>
                Si vous décidez de poursuivre immédiatement, certaines fonctionnalités risquent de ne pas fonctionner
                correctement.
            </Typography>
        </DefaultDialog>
    )
}

export default NoEndpointsAlert
